/**
 * Picks the key/value pairs from the given object that return true for the
 * given filter.
 * @param obj The object to pick from.
 * @param filter A filter function that will be called with each key/value pair.
 * @param modKey A function receiving the key, and returning the new key.
 * @return The filtered object.
 */
export default function pickBy(obj, filter, modKey) {
    var toReturn = {};
    for (var key in obj) {
        var val = obj[key];
        if (filter(key, val)) {
            var newKey = modKey ? modKey(key) : key;
            toReturn[newKey] = val;
        }
    }
    return toReturn;
}
